export enum AccountUserStatusKind {
    PENDING = 0,
    DISABLED = 1,
    ENABLED = 2
}
